import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import LoginGate from "@/components/LoginGate";
import Dashboard from "@/pages/Dashboard";

function Gated() {
  const { authed, checking } = useAuth();
  if (checking) {
    return (
      <div
        data-testid="auth-checking"
        className="min-h-screen flex items-center justify-center font-mono text-[11px] uppercase tracking-[0.25em] opacity-60"
      >
        Loading…
      </div>
    );
  }
  return authed ? <Dashboard /> : <LoginGate />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Gated />} />
        </Routes>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              borderRadius: 0,
              border: "1px solid #0a0a0a",
              background: "#fff",
              color: "#0a0a0a",
              fontFamily: "'IBM Plex Mono', monospace",
              fontSize: "12px",
            },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}
